import Script from 'next/script';
import { log } from 'constants/config';
import { shouldHardBlock } from 'constants/geoBlocking';

export default function GoogleMapsScriptOptimized() {
  // Only skip loading Google Maps in HARD block mode
  // In soft block mode, we still load the script (it's free, needed for autocomplete)
  if (shouldHardBlock()) {
    log('[GoogleMapsScript] Hard block - skipping Google Maps load');
    if (typeof window !== 'undefined') {
      (window as any).__googleMapsBlocked = true;
    }
    return null;
  }

  return (
    <Script
      id="google-maps"
      src={`https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_API_KEY}&libraries=places,geometry`}
      strategy="afterInteractive"
      onLoad={() => {
        log('[GoogleMapsScript] Google Maps loaded', {
          timestamp: new Date().toISOString(),
          hasGoogle: !!window.google,
          hasGoogleMaps: !!window.google?.maps,
          hasGeocoder: !!window.google?.maps?.Geocoder,
          hasPlaces: !!window.google?.maps?.places,
        });

        if (typeof window !== 'undefined') {
          (window as any).__googleMapsLoaded = true;
        }
      }}
      onError={(error) => {
        log('[GoogleMapsScript] Failed to load Google Maps script', error);
        if (typeof window !== 'undefined') {
          (window as any).__googleMapsError = error;
        }
      }}
    />
  );
}
